module.exports = __webpack_public_path__ + "static/media/1009855.d20d5687.jpg";